/**
 * 設備、語言、頻道相關常量
 */

export const DEVICE_TYPES = {
  WEB: 'web',
  ANDROID: 'android',
  IOS: 'ios',
  PC: 'pc',
} as const;

export const CHANNELS = {
  AILE_LITE: 'AileLite',
  AILE: 'Aile',
  AIWOW: 'Aiwow',
  WEBCHAT: 'Webchat',
} as const;

export const SUPPORTED_LANGUAGES = {
  'zh-TW': '繁體中文',
  'zh-CN': '簡體中文',
  'en-US': 'English',
} as const;
